import { requestRaw } from './http/apiClient';
import { fileToPureBase64, stripBase64Prefix } from '../utils/files';

const PUT_RESEND = '/v1/accountmanager/resenddocs';
export const MAX_MB = 6;
export const ACCEPTED = ['image/jpeg', 'image/png', 'application/pdf'];

export async function toPureBase64(file) {
  return fileToPureBase64(file);
}

function prepareFiles(filesMap = {}, sendEmptyKeys = false) {
  const possibleKeys = [
    'identification',
    'selfie',
    'address_proof',
    'balance_sheet',
    'social_contract',
    'additional_document_one',
    'additional_document_two',
  ];

  const out = {};
  for (const k of possibleKeys) {
    const v = filesMap[k];
    if (!v) continue;
    const pure = typeof v === 'string' ? stripBase64Prefix(v) : v;
    if (pure) out[k] = pure;
  }

  if (sendEmptyKeys) {
    for (const k of possibleKeys) {
      if (!(k in out)) out[k] = '';
    }
  }

  return out;
}

export async function resendDocuments(email, filesMap = {}, { sendEmptyKeys = false } = {}) {
  if (!email) throw new Error('Falta el email.');

  const { ok, status, text } = await requestRaw({
    path: PUT_RESEND,
    method: 'PUT',
    body: { email, files: prepareFiles(filesMap, sendEmptyKeys) },
    casing: 'lower',
    includeAuth: true,
    accept: 'text/plain',
    contentType: 'application/json',
  });

  if (!ok) throw new Error(`HTTP ${status} ${text || 'Server Error'}`);

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}




